/**
 * Default word limit applied to AI tool text inputs (typed text, selected
 * lesson content and counted textareas). Fields can override it via their
 * config `wordLimit`; passing `null` disables the limit entirely.
 */
export const DEFAULT_WORD_LIMIT = 50000;

export function countWords(text: unknown): number {
  if (!text || typeof text !== 'string') return 0;
  const trimmed = text.trim();
  return trimmed === '' ? 0 : trimmed.split(/\s+/).length;
}
